var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2114 3.61281C12.8618 2.96144 13.9167 2.96104 14.5675 3.61192L16.6441 5.68846C17.2894 6.33378 17.2961 7.37849 16.6591 8.03205L15.2755 9.45163L10.8251 5.00122L12.2114 3.61281ZM9.9419 5.88577L14.403 10.3469L8.96484 15.9264C8.49449 16.409 7.84939 16.6811 7.17576 16.6811L4.88231 16.681C4.17162 16.681 3.60405 16.0885 3.63394 15.3779L3.7324 13.0371C3.75874 12.4111 4.01892 11.8177 4.46148 11.3745L9.9419 5.88577ZM17.5961 17.246C17.9411 17.246 18.2208 16.9661 18.2208 16.6207C18.2208 16.2754 17.9411 15.9955 17.5961 15.9955H12.4946C12.1496 15.9955 11.8699 16.2754 11.8699 16.6207C11.8699 16.9661 12.1496 17.246 12.4946 17.246H17.5961Z",
    fill: "#0D4740"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditFilled);
export default __webpack_public_path__ + "static/media/edit-filled.71248eea605b2b1f6970590a8e84d1fb.svg";
export { ForwardRef as ReactComponent };